import React from 'react'
import {useBreakpoint} from '../../../libs/breakpoint'
import MessengerRouterMobile from "./MessengerRouterMobile";
import MessengerRouterDesktop from "./MessengerRouterDesktop";

const Messenger = () => {
    const breakpoints = useBreakpoint();
    return breakpoints.md ? <MessengerRouterMobile/> : <MessengerRouterDesktop/>;
}

export default Messenger;